export enum DayOfWeek {
  SUNDAY = "SUNDAY",
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
}

export enum DayPreference {
  DAILY = "DAILY",
  DAY_RANGE = "DAY_RANGE",
  EVERY_SELECTED_DAYS = "EVERY_SELECTED_DAYS",
  PARTICIPANT_PREFERENCE = "PARTICIPANT_PREFERENCE",
}

export enum GoalAction {
  REACHED = "REACHED",
  SET = "SET",
}

export enum Icon {
  BABY = "BABY",
  DIAMOND = "DIAMOND",
  FIVE_STAR = "FIVE_STAR",
  FLOWER = "FLOWER",
  FOUR_STAR = "FOUR_STAR",
  GEMSTONE = "GEMSTONE",
  GROUP = "GROUP",
  HEART = "HEART",
  HOME = "HOME",
  MONEY = "MONEY",
  PENCIL = "PENCIL",
  TOOL = "TOOL",
  WINGS = "WINGS",
  PLANT = "PLANT",
}

export enum Level {
  NOVICE = "NOVICE",
  BRONZE = "BRONZE",
  SILVER = "SILVER",
  GOLD = "GOLD",
  DIAMOND = "DIAMOND",
}

export enum Priority {
  NORMAL = "NORMAL",
  HIGH = "HIGH",
  CRITICAL = "CRITICAL",
}

export enum TaskStatus {
  ASSIGNED = "ASSIGNED",
  COMPLETE = "COMPLETE",
  EXCUSED = "EXCUSED",
  INCOMPLETE = "INCOMPLETE",
}

export enum TaskType {
  INDIVIDUAL_GOAL = "INDIVIDUAL_GOAL",
  OPTIONAL = "OPTIONAL",
  REQUIRED = "REQUIRED",
}

export enum TimePreference {
  ANYTIME = "ANYTIME",
  PARTICIPANT_PREFERENCE = "PARTICIPANT_PREFERENCE",
  SPECIFIC = "SPECIFIC",
}

export enum TransactionType {
  EARNING = "EARNING",
  PURCHASE = "PURCHASE",
  REFUND = "REFUND",
}
